import request from '../services/request'
import memoizeOne from 'memoize-one'
import compose from 'lodash/fp/compose';

/**
 * make request function with authorization header
 *
 * @memoized by token
 * @param {String} token - authorization token
 * @return {(String, Options) => Promise} configured request with auth function
 */
export const makeAuthRequest = memoizeOne(token =>
  (endpoint, options = {}) => request(endpoint, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${token}`
    }
  })
)

/**
 * creates api with injected authRequest
 * @signature (fn -> object) -> string -> object
 */
export const createAuthedApi = apiCreator => memoizeOne(
  /** string -> Object<Function> */
  compose(apiCreator, makeAuthRequest)
)
